import React, { useState, useRef, useEffect, useContext } from "react";
import { Grid, Segment, Loader, Dimmer, Image } from 'semantic-ui-react'
import { useHistory, NavLink } from "react-router-dom";
import moment from "moment";
import "./StartContestScreen.scss";
import { Config } from "../../common"
import atar_logo from "../../assets/home/atar_logo.png";
import timeicon from "../../assets/home/timing_clock.png";
import loaderGif from "../../assets/loader.gif";
import tickCompleted from "../../assets/home/checked_new.svg";
import { StarButton } from '../../components'
import { useSelector, useDispatch } from 'react-redux'
import { triviaQuestionsById, updateContestant } from '../../store/TriviaRedux'
import { singleUser } from '../../store/UserRedux'
import { useTranslation } from "react-i18next";
// import useConfirmBrowserExit from "./useConfirmBrowserExit";

const StartContestScreen = () => {
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const currentUser = useSelector((state) => state.auth.user)
  const isFetching = useSelector((state) => state.trivia.isFetching)
  const triviaInfo = useSelector((state) => state.trivia.triviaInfo)
  const questions = useSelector((state) => state.trivia.questions)

  const [sec, SetSec] = useState(1);
  const [min, setMin] = useState(0);
  const [hour, setHour] = useState(0);
  const [isTimeLoad, setIsTimeLoad] = useState(true);
  const [Loading, setloading] = useState(true);
  const [step, setStep] = useState(0);
  const [clicked, setClicked] = useState(-1);
  const [questionBank, setQuestionBank] = useState(null);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const Qtype = { 0: 'A', 1: 'B', 2: 'C', 3: 'D', 4: 'E', 5: 'F' }

  useEffect(() => {
    window.scrollTo(0, 0)
    if (questions && questions._id) {
      let params = { contestantId: `${questions._id}`, token }
      dispatch(triviaQuestionsById(params))
    }
  }, []);

  useEffect(() => {
    const handleTabClose = event => {
      event.preventDefault();
      return (event.returnValue = 'Are you sure you want to exit?');
    };
    window.addEventListener('beforeunload', handleTabClose);
    return () => {
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, []);


  useEffect(async () => {
    setloading(true);
    if (questions && questions.triviaCompleted) {
      dispatch(singleUser({ id: currentUser._id, token }));
      if (questions?.questionBank.length === questions.score) {
        history.push("/SuccessContest");
      } else {
        history.push("/WorngContest");
      }
      return
    }

    if (questions) {
      if (isTimeLoad) {
        let end = moment.utc(new Date());
        let startTime = moment.utc(new Date(questions.timeStarted));
        var duration = moment.duration(end.diff(startTime));
        setHour(duration._data.hours)
        setMin(duration._data.minutes)
        SetSec(duration._data.seconds)
        setIsTimeLoad(false)
      }
      let lastStep = questions.lastStep == 5 ? 4 : questions.lastStep
      // if (questions && questions.questionBank && questions.questionBank[lastStep + 1]) {
      //   let isAttempt = questions.questionBank[lastStep + 1].attempt
      //   if (isAttempt > 0) {
      setStep(lastStep);
      let questionBank = questions?.questionBank[lastStep]
      setQuestionBank(questionBank)
      let selectedkey = questionBank.options.findIndex(x => x.selected == true);
      setClicked(selectedkey);
      //   }
      // }
    }
    setloading(false);
  }, [questions]);

  useEffect(() => {
    setTimeout(() => {
      if (sec % 60 === 0) {
        setMin(min + 1);
        SetSec(1);
      } else {
        SetSec(sec + 1);
      }
    }, 1000);
  }, [sec]);


  const preQuestions = () => {
    setStep(step - 1);
    let questionBank = questions?.questionBank[step - 1]
    setQuestionBank(questionBank)
    let selectedkey = questionBank.options.findIndex(x => x.selected == true);
    setClicked(selectedkey);
  }

  const nextQuestions = () => {
    setStep(step + 1);
    let questionBank = questions?.questionBank[step + 1]
    setQuestionBank(questionBank)
    let selectedkey = questionBank.options.findIndex(x => x.selected == true);
    setClicked(selectedkey);
  }

  const answerQuestions = (key) => {
    let params = {
      contestantId: questions._id,
      questionId: questions.questionBank[step].questionId,
      optionIndex: key,
    };
    setClicked(key);
    params.token = token
    dispatch(updateContestant(params))
  };

  const gotoPage = () => {
    let params = { contestantId: `${questions._id}/end`, token }
    dispatch(triviaQuestionsById(params))
  }

  let basicDetails = Config.GetLanguage(triviaInfo, i18n.language, 'basicDetails')
  let title = basicDetails?.title ? basicDetails?.title : null
  let basicDetailsTrans = Config.GetLanguageSameLine(questionBank, i18n.language)
  return (
    <>
      {/* <useConfirmBrowserExit /> */}
      <div className="container-fluid home clearall">
        <div className="contestflow_sec">
          <NavLink
            to="">
            <img className="star_img" src={atar_logo} />
          </NavLink>

          <div className="lifet">
            <Grid stackable columns={2}>
              <Grid.Column>
                <div className="experience">
                  {triviaInfo.mainContestListingMobileViewImage && (<img className="sarukhan_img" src={triviaInfo.mainContestListingMobileViewImage} />)}
                  <div className="dummy_text">
                    {title && (<h5>{(title).split(' ')[0]} <span> {title.substring(title.indexOf(" ") + 1, title.length)}</span></h5>)}
                    <p>{basicDetails?.about} </p>
                  </div>
                </div>

              </Grid.Column>
              <Grid.Column>
                <div className="time_right clearall">

                  {/* stepper_sec _start*/}
                  <div className="bs-stepper clearall">
                    <div className="bs-stepper-header" role="tablist">
                      {[1, 2, 3, 4, 5].map((item) => <><div className="step " data-target="#logins-part">
                        <button
                          type="button"
                          className="step-trigger"
                          role="tab"
                          aria-controls="logins-part"
                          id="logins-part-trigger"
                        >
                          <span
                            className={(step + 1) >= item ? "bs-stepper-circle clicked" : "bs-stepper-circle"}
                            onClick={() => preQuestions()}
                          >
                            {item}
                          </span>
                        </button>
                      </div>
                        {item < 5 && (<div className={(step + 1) > item ? "line lineAct" : "line"}></div>)}</>)}
                    </div>
                  </div>
                  {/* stepper_sec end*/}
                  <div className="questnum">
                    <Grid columns={2}>
                      <Grid.Column><h5>Question {step + 1} of {questions?.questionBank?.length}</h5></Grid.Column>
                      <Grid.Column> <div className="rukh">
                        <img className="timeicon" src={timeicon} />
                        {`${"0" + hour}h:${("0" + min).slice(-2)}m:${("0" + sec).slice(-2)}s`}
                      </div></Grid.Column>
                    </Grid>
                  </div>

                  <div className="question_sec clearall">
                    <div className="frist clearall ">
                      <h6>{basicDetailsTrans?.statement}</h6>
                    </div>

                    {(basicDetailsTrans) ? (<>
                      {basicDetailsTrans.options.map((item, key) => <div key={key}
                        onClick={() => answerQuestions(key)}
                        style={{ cursor: "pointer" }}
                        className={"dileale clearall " + (clicked === key && ("active"))}>
                        <div className="round_a">{Qtype[key]}</div>
                        <h5>{item.value}</h5>
                      </div>)}

                    </>) : <div className="clearall">
                      <Segment style={{ minHeight: 100 }}>
                        <Dimmer active >
                          <Image src={loaderGif} />
                        </Dimmer>
                      </Segment>
                    </div>}
                  </div>
                  <div className="next_sec destops clearall" style={{ display: "block" }}>
                    <div style={{ width: "20%", display: "inline-block" }}>{(step > 0 && !isFetching) && (<div onClick={() => preQuestions()} className="back_arrow"><i className="fa fa-arrow-left" aria-hidden="true"></i><span> Back</span></div>)}</div>
                    <div style={{ width: "60%", display: "inline-block" }}>{questions.questionBank[4].attempt > 0 ? <StarButton background="mainBg" title={t("startcontest.btn")} onClickAction={() => gotoPage()} /> : null}</div>
                    <div style={{ width: "20%", display: "inline-block" }}>{(!isFetching && step < 4 && clicked != -1) && (<div onClick={() => nextQuestions()} className="back_arrow"><span>Next </span><i className="fa fa-arrow-right" aria-hidden="true"></i></div>)}</div>
                  </div>
                </div>
              </Grid.Column>
            </Grid>

          </div>
        </div>

        <div className="next_sec mobiles">
          {(step > 0 && !isFetching) && (<div onClick={() => preQuestions()} className="back_arrow"><i className="fa fa-arrow-left" aria-hidden="true"></i><span> Back</span></div>)}
          {questions.questionBank[4].attempt > 0 ? <StarButton background={"mainBg"} title={t("startcontest.btn")} onClickAction={() => gotoPage()} /> : null}
          {(!isFetching && step < 4 && clicked != -1) && (<div onClick={() => nextQuestions()} className="back_arrow"><span>Next </span><i className="fa fa-arrow-right" aria-hidden="true"></i></div>)}
        </div>

      </div>
    </>
  );
};

export default StartContestScreen
